<script lang="ts">
  import { createEventDispatcher } from "svelte"
  import TestCaseIndicator from "./TestCaseIndicator.svelte"
  export let evaluation:boolean | null = null
  export let inputType:"code"|"interact" = "code"
  export let isSelected:boolean = true
  export let index:number
  let dispatch = createEventDispatcher()

  function handleClick() {
    dispatch("selected")
  }
</script>

<button data-testid="{"testCaseTab" + index}" class:selected="{isSelected}" class:deselected="{!isSelected}" on:click={handleClick}>
  <TestCaseIndicator evaluation={evaluation} 
    neutral={inputType == "code" ? "😐" : "✋"}
    positive={inputType == "code" ? "😊" : "👍"}
    negative={inputType == "code" ? "☹️" : "👎"}
  ></TestCaseIndicator>
</button>

<style>
  .selected {
    @apply p-2;
    @apply border-b-2;
    @apply border-solid;
    @apply border-orange;
  }

  .deselected {
    @apply p-2;
  }

  .deselected:hover {
    @apply bg-darkBackHigh;
    @apply text-darkForeHigh;
  }
</style>